// Group enum equivalent
const PaymentErrorGroup = {
  GROUP1: "group1",
  GROUP2: "group2",
  GROUP3: "group3",
  GROUP4: "group4",
  GROUP5: "group5",
  GROUP6: "group6",
  GROUP7: "group7",
  GROUP8: "group8", // Try again
  GROUP9: "group9", // Try again + Contact member care
  GROUP10: "group10", // Contact member care
};

// Payment error codes
const PaymentError = {
  referToCardIssuer: 1,
  invalidMerchant: 3,
  pickUpCard: 4,
  doNotHonor: 5,
  invalidTransaction: 12,
  invalidAmount: 13,
  invalidCardNumber: 14,
  noSuchIssuer: 15,
  formatError: 30,
  lostCard: 41,
  noUniversalAcount: 42,
  stolenCard: 43,
  insufficientFunds: 51,
  expiredCard: 54,
  transactionNotPermittedToCardholder: 57,
  transactionNotPermittedToAcquire: 58,
  exceedsWithdrawalAmountLimit: 61,
  restrictedCard: 62,
  exceedsWithdrawalFrequencyLimit: 65,
  reservedForPrivateUse: 81,
  issuerOrSwitchInoprative: 91,
  financialInstitutionCannotBeFoundForRoutin: 92,
  systemMalfunction: 96,

  // Payment Authorisation (negative values)
  abandoned: 301,
  canceled: 302,
  deferred: 303,
  expired: 304,
  failed: 401,
  failedInvalidParameter: 402,
  failedDuplicate: 403,
  failedLocked: 404,
  failedInvalidCardNo: 405,
  failedInvalidExpiry: 406,
  failedExpiredCard: 407,
  failedUnspecifiedFailure: 408,
  declined: 501,
  declinedIncorrectCSCCVV: 502,
  declined3DSecurityIncorrect: 503,
  declined3DSecurityCardNotEnrolled: 504,
  declinedInsufficientFunds: 505,
  declinedTransactionTypeNotSupported: 506,
  declinedCardIssuer: 507,
  declinedCardIssuerNoReply: 508,
  declinedCardIssuerDoNotContact: 509,
  declinedCardIssuerReferralResponse: 510,
  declinedCardIssuerError: 511,
  declinedNotAuthenticated: 512,
  declinedCardAcquirerError: 513,
  declinedCardIssuerRiskCheck: 514,
  declinedTap: 515,
  declinedAuthenticationFailed: 516,
  void: 601,
  restricted: 701,
  restrictedRetryLimitExceeded: 702,
  restrictedBank: 703,
  restrictedTap: 704,
  timedOut: 801,
  unknown: 901,
  headerValuesAreMissing: 1100,
  secretAPIKeyAndEnvironmentAreMismatched: 1101,
  requestValuesAreEmpty: 1102,
  requiredInputsAreInvalid: 1103,
  customerIdIsMissing: 1104,
  customerIdIsInvalid: 1105,
  customerNotFound: 1106,
  customerIdIsNotMatchingWithExistingCustomer: 1107,
  saveCardFeaturesAreNotEnabled: 1108,
  non3DSecureTransactionsAreNotAllowed: 1109,
  redirectURLIsMissing: 1110,
  redirectURLIsInvalid: 1111,
  authorizeIdIsMissing: 1112,
  authorizeIdIsInvalid: 1113,
  pleaseCheckTheAuthorizeStatus: 1114,
  authorizeNotFound: 1115,
  saveCardFeatureNotSupportedForThisTransaction: 1116,
  amountIsInvalid: 1117,
  currencyCodeIsInvalid: 1118,
  currencyCodeNotSupported: 1119,
  statementDescriptorInvalidOrTooLong: 1120,
  descriptionTooLong: 1121,
  merchantOrderReferenceTooLong: 1122,
  merchantTransactionReferenceTooLong: 1123,
  sourceIdIsMissing: 1124,
  sourceIdIsInvalid: 1125,
  sourceAlreadyUsedPleaseCreateNewSource: 1126,
  metadataKeyTooLong: 1127,
  metadataValueTooLong: 1128,
  customerIdOrCustomerInformationIsRequired: 1129,
  customerFirstNameIsRequired: 1130,
  customerFirstNameTooLong: 1131,
  customerLastNameIsRequired: 1132,
  customerLastNameTooLong: 1133,
  customerMiddleNameTooLong: 1134,
  phoneNumberIsRequired: 1135,
  phoneNumberCountryCodeIsInvalid: 1136,
  phoneNumberIsInvalid: 1137,
  emailAddressIsInvalid: 1138,
  customerPhoneOrEmailRequired: 1139,
  cardNumberIsInvalid: 1140,
  cardExpiryIsInvalid: 1141,
  chargeIdIsMissing: 1142,
  chargeIdIsInvalid: 1143,
  chargeIdNotFound: 1144,
  authenticateTypeIsMissing: 1145,
  authenticateTypeIsInvalid: 1146,
  confirmationCodeIsMissing: 1147,
  confirmationCodeIsInvalid: 1148,
  currencyCodeNotMatching: 1149,
  captureAmountExceedsAuthorized: 1150,
  gatewayTimedOut: 1151,
  invalidAuthorizeAutoScheduleType: 1152,
  invalidAuthorizeAutoScheduleTime: 1153,
  binIsMissing: 1154,
  binIsInvalid: 1155,
  refundReasonIsMissing: 1156,
  refundReasonTooLong: 1157,
  refundIdIsMissing: 1158,
  refundIdIsInvalid: 1159,
  refundNotFound: 1160,
  requestedRefundAmountExceeds: 1161,
  invalidRowCountTooLarge: 1162,
  cardNotSupportedTryAnother: 1163,
  merchantIdIsInvalid: 1164,
  transferIdIsMissing: 1165,
  transferIdIsInvalid: 1166,
  transferNotFound: 1167,
  requestedTransferAmountExceedsChargeAmount: 1168,
  destinationAndApplicationConflict: 1169,
  transferCurrencyCodeIsInvalid: 1170,
  destinationIdDuplicated: 1171,
  destinationIdInvalid: 1172,
  invalidJsonRequest: 2100,
  serverUnavailable: 2101,
  requestNotFound: 2102,
  applicationRequired: 2103,
  invalidApiKey: 2104,
  apiCredentialsAreRequired: 2105,
  useSecretKeyNotPublic: 2106,
  authorizationRequired: 2107,
  permissionGrantRequired: 2108,
  invalidInputsCurrencyOrAmount: 9998,
  internalServerError: 9999,
  cardValidationFailedCardNameCanOnlyHave10IntegerValues: 4100,
  cardValidationFailedCardHasExpired: 4101,
  cardValidationFailedCVCIsTooShortLong: 4102,
};

// Mapping from error code → group
const getErrorGroup = (errorCode) => {
  switch (errorCode) {
    case PaymentError.referToCardIssuer:
    case PaymentError.invalidMerchant:
    case PaymentError.pickUpCard:
    case PaymentError.doNotHonor:
    case PaymentError.invalidTransaction:
    case PaymentError.invalidAmount:
    case PaymentError.noSuchIssuer:
    case PaymentError.transactionNotPermittedToAcquire:
    case PaymentError.exceedsWithdrawalAmountLimit:
    case PaymentError.restrictedCard:
    case PaymentError.exceedsWithdrawalFrequencyLimit:
    case PaymentError.reservedForPrivateUse:
    case PaymentError.issuerOrSwitchInoprative:
    case PaymentError.financialInstitutionCannotBeFoundForRoutin:    
    case PaymentError.formatError:
    case PaymentError.lostCard:
    case PaymentError.noUniversalAcount:
    case PaymentError.stolenCard:
      return PaymentErrorGroup.GROUP2;

    case PaymentError.invalidCardNumber:
      return PaymentErrorGroup.GROUP3;

    case PaymentError.insufficientFunds:
      return PaymentErrorGroup.GROUP4;

    case PaymentError.expiredCard:
      return PaymentErrorGroup.GROUP5;

    case PaymentError.transactionNotPermittedToCardholder:
      return PaymentErrorGroup.GROUP6;

    case PaymentError.systemMalfunction:
      return PaymentErrorGroup.GROUP7;

    case PaymentError.abandoned:
    case PaymentError.canceled:
    case PaymentError.expired:
    case PaymentError.failedInvalidParameter:
    case PaymentError.failedInvalidCardNo:
    case PaymentError.failedInvalidExpiry:
    case PaymentError.failedExpiredCard:
    case PaymentError.declinedIncorrectCSCCVV:
    case PaymentError.declined3DSecurityIncorrect:
    case PaymentError.declined3DSecurityCardNotEnrolled:
    case PaymentError.declinedInsufficientFunds:
      return PaymentErrorGroup.GROUP8;

    case PaymentError.deferred:
    case PaymentError.failed:
    case PaymentError.failedDuplicate:
    case PaymentError.failedLocked:
    case PaymentError.failedUnspecifiedFailure:
    case PaymentError.declined:
    case PaymentError.declinedTransactionTypeNotSupported:
    case PaymentError.declinedCardIssuer:
    case PaymentError.declinedCardIssuerNoReply:
    case PaymentError.declinedCardIssuerDoNotContact:
    case PaymentError.declinedCardIssuerReferralResponse:
    case PaymentError.declinedCardIssuerError:
    case PaymentError.declinedNotAuthenticated:
    case PaymentError.declinedCardAcquirerError:
    case PaymentError.declinedCardIssuerRiskCheck:
    case PaymentError.declinedTap:
    case PaymentError.declinedAuthenticationFailed:
    case PaymentError.void:
    case PaymentError.restricted:
    case PaymentError.restrictedRetryLimitExceeded:
    case PaymentError.restrictedBank:
    case PaymentError.restrictedTap:
    case PaymentError.timedOut:
    case PaymentError.headerValuesAreMissing:
    case PaymentError.secretAPIKeyAndEnvironmentAreMismatched:
    case PaymentError.requestValuesAreEmpty:
    case PaymentError.requiredInputsAreInvalid:
    case PaymentError.customerIdIsMissing:
    case PaymentError.customerIdIsInvalid:
    case PaymentError.customerNotFound:
    case PaymentError.customerIdIsNotMatchingWithExistingCustomer:
    case PaymentError.saveCardFeaturesAreNotEnabled:
    case PaymentError.non3DSecureTransactionsAreNotAllowed:
    case PaymentError.redirectURLIsMissing:
    case PaymentError.redirectURLIsInvalid:
    case PaymentError.authorizeIdIsMissing:
    case PaymentError.authorizeIdIsInvalid:
    case PaymentError.pleaseCheckTheAuthorizeStatus:
    case PaymentError.authorizeNotFound:
    case PaymentError.saveCardFeatureNotSupportedForThisTransaction:
    case PaymentError.amountIsInvalid:
    case PaymentError.currencyCodeIsInvalid:
    case PaymentError.currencyCodeNotSupported:
    case PaymentError.statementDescriptorInvalidOrTooLong:
    case PaymentError.descriptionTooLong:
    case PaymentError.merchantOrderReferenceTooLong:
    case PaymentError.merchantTransactionReferenceTooLong:
    case PaymentError.sourceIdIsMissing:
    case PaymentError.sourceIdIsInvalid:
    case PaymentError.sourceAlreadyUsedPleaseCreateNewSource:
    case PaymentError.metadataKeyTooLong:
    case PaymentError.metadataValueTooLong:
    case PaymentError.customerIdOrCustomerInformationIsRequired:
    case PaymentError.customerFirstNameIsRequired:
    case PaymentError.customerFirstNameTooLong:
    case PaymentError.customerLastNameIsRequired:
    case PaymentError.customerLastNameTooLong:
    case PaymentError.customerMiddleNameTooLong:
    case PaymentError.phoneNumberIsRequired:
    case PaymentError.phoneNumberCountryCodeIsInvalid:
    case PaymentError.phoneNumberIsInvalid:
    case PaymentError.emailAddressIsInvalid:
    case PaymentError.customerPhoneOrEmailRequired:
    case PaymentError.cardNumberIsInvalid:
    case PaymentError.cardExpiryIsInvalid:
    case PaymentError.chargeIdIsMissing:
    case PaymentError.chargeIdIsInvalid:
    case PaymentError.chargeIdNotFound:
    case PaymentError.authenticateTypeIsMissing:
    case PaymentError.authenticateTypeIsInvalid:
    case PaymentError.confirmationCodeIsMissing:
    case PaymentError.confirmationCodeIsInvalid:
    case PaymentError.currencyCodeNotMatching:
    case PaymentError.captureAmountExceedsAuthorized:
    case PaymentError.gatewayTimedOut:
    case PaymentError.invalidAuthorizeAutoScheduleType:
    case PaymentError.invalidAuthorizeAutoScheduleTime:
    case PaymentError.binIsMissing:
    case PaymentError.binIsInvalid:
    case PaymentError.refundReasonIsMissing:
    case PaymentError.refundReasonTooLong:
    case PaymentError.refundIdIsMissing:
    case PaymentError.refundIdIsInvalid:
    case PaymentError.refundNotFound:
    case PaymentError.requestedRefundAmountExceeds:
    case PaymentError.invalidRowCountTooLarge:
    case PaymentError.cardNotSupportedTryAnother:
    case PaymentError.merchantIdIsInvalid:
    case PaymentError.transferIdIsMissing:
    case PaymentError.transferIdIsInvalid:
    case PaymentError.transferNotFound:
    case PaymentError.requestedTransferAmountExceedsChargeAmount:
    case PaymentError.destinationAndApplicationConflict:
    case PaymentError.transferCurrencyCodeIsInvalid:
    case PaymentError.destinationIdDuplicated:
    case PaymentError.destinationIdInvalid:
    case PaymentError.invalidJsonRequest:
    case PaymentError.serverUnavailable:
    case PaymentError.requestNotFound:
    case PaymentError.applicationRequired:
    case PaymentError.invalidApiKey:
    case PaymentError.apiCredentialsAreRequired:
    case PaymentError.useSecretKeyNotPublic:
    case PaymentError.authorizationRequired:
    case PaymentError.permissionGrantRequired:
    case PaymentError.invalidInputsCurrencyOrAmount:
    case PaymentError.internalServerError:
    case PaymentError.cardValidationFailedCardNameCanOnlyHave10IntegerValues:
    case PaymentError.cardValidationFailedCardHasExpired:
    case PaymentError.cardValidationFailedCVCIsTooShortLong:
      return PaymentErrorGroup.GROUP9;
    case PaymentError.unknown:
      return PaymentErrorGroup.GROUP10;
    default:
      return PaymentErrorGroup.GROUP8;
  }
}

export { PaymentError, PaymentErrorGroup, getErrorGroup };
